module.exports = __webpack_public_path__ + "static/img/lv1.772990b5.png";